<template>
  <div>
    <b-modal
      v-model="showSubmitDeclarationModal"
    >
      Czy na pewno chcesz złożyć tę deklarację? Tej czynności nie da się cofnąć.

      <p v-if="declarationType === 'A'">
        Pamiętaj! Jeżeli w budynku znajduje się lokal lub lokale niemieszkalne ogrzewane źródłem ciepła nieuwzględnionym w niniejszej deklaracji, złóż również deklarację B.
      </p>

      <p v-if="declarationType === 'B'">
        Pamiętaj! Jeżeli w budynku znajduje się lokal lub lokale mieszkalne ogrzewane źródłem ciepła nieuwzględnionym w niniejszej deklaracji, złóż także deklarację A.
      </p>

      <template #modal-footer="{ ok, cancel }">
        <b-button class="btn btn-primary" @click="saveDeclaration(false)">
          Tak, złóż
        </b-button>
        <b-button @click="cancel()">
          Cofnij
        </b-button>
      </template>
    </b-modal>

    <notifications group="declaration" position="top center" classes="zone-notification-declaration"/>
    <div class="around-fade"></div>
    <div class="zone-modal">
      <b-overlay
        class="declaration-overlay"
        rounded="lg"
        :show="!dataLoaded && !!declarationEditId"
        v-if="!dataLoaded && !!declarationEditId"
      />

      <CloseModalButton :on-click="closeDeclarationModal"></CloseModalButton>

      <div class="header">
        <h1>Deklaracja dotycząca źródeł ciepła i źródeł spalania paliw</h1>
        <h1>{{ declarationTypeTitle }}</h1>
      </div>
      <div class="progress-bar-block">
        <ProgressBar
          :current-step="step"
          :address-is-same="thirdScreenData.isAddressSame"
          :no-solid-fuel="!secondScreenData.solidFuel"
          @changeStep="setStep"
        />
      </div>

      <div class="form-block" style="=padding-top: 0 !important;">
        <FirstScreen
          :building="building"
          @update="setFirstScreenData"
          v-show="step === 1"
          ref="screen1"
        />
        <SecondScreen
          :building="building"
          @update="setSecondScreenData"
          v-show="step === 2"
          ref="screen2"
        />
        <BoilersClassesScreen
          :building="building"
          @update="setBoilersClassesData"
          v-show="step === 3"
          ref="screen3"
        />
        <FuelTypesScreen
          :building="building"
          v-show="step === 4"
          @update="setFuelTypesData"
          ref="screen4"
        />
        <ThirdScreen
          :building="building"
          @update="setThirdScreenData"
          v-show="step === 5"
          ref="screen5"
        />
        <CustomAddressScreen
          :building="building"
          v-show="step === 6"
          @update="setCustomAddressData"
          ref="screen6"
        />

      </div>

      <div class="buttons-row">
        <button type="button" class="btn btn-primary" @click="moveToNextStepOrSave">
          {{ nextStepButtonText }}
        </button>
        <button type="button" class="btn btn-outline-primary" @click="saveDeclaration(true)">
          Zapisz wersję roboczą
        </button>
        <button
          type="button"
          class="btn btn-link"
          @click="stepBack"
          v-if="this.step > 1"
        >
          Wstecz
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import _ from "lodash";
import DeclarationsModel from "@/models/declarations";
import ProgressBar from "@/components/declarations/ProgressBar";
import CloseModalButton from "@/components/common/CloseModalButton";
import FirstScreen from "@/components/declarations/FirstScreen";
import SecondScreen from "@/components/declarations/SecondScreen";
import ThirdScreen from "@/components/declarations/ThirdScreen";
import BoilersClassesScreen from "@/components/declarations/BoilersClassesScreen";
import FuelTypesScreen from "@/components/declarations/FuelTypesScreen";
import CustomAddressScreen from "@/components/declarations/CustomAddressScreen";
import Screen1 from "@/components/declarations/validators/Screen1";
import Screen2 from "@/components/declarations/validators/Screen2";
import BoilersClasses from "@/components/declarations/validators/BoilersClasses";
import FuelTypes from "@/components/declarations/validators/FuelTypes";
import Screen3 from "@/components/declarations/validators/Screen3";
import CustomAddress from "@/components/declarations/validators/CustomAddress";
import DeclarationsMixin from "@/mixins/DeclarationsMixin";


export default {
  name: "DeclarationModal",
  components: {
    CustomAddressScreen,
    FuelTypesScreen,
    BoilersClassesScreen, ThirdScreen, SecondScreen, FirstScreen, CloseModalButton, ProgressBar
  },
  mixins: [DeclarationsMixin],
  data() {
    return {
      validators: {
        screen1: Screen1,
        screen2: Screen2,
        screen3: BoilersClasses,
        screen4: FuelTypes,
        screen5: Screen3,  // naming issues as there are
        screen6: CustomAddress,
      },
      step: 1,
      firstScreenData: {},
      secondScreenData: {},
      fuelTypesData: {},
      thirdScreenData: {
        isAddressSame: true
      },
      boilersClassesData: {},
      customAddressData: {},

      dataLoaded: false,

      showSubmitDeclarationModal: false
    }
  },
  methods: {
    setCustomAddressData(data) {
      this.customAddressData = data;
    },
    setFuelTypesData(data) {
      this.fuelTypesData = data;
    },
    setBoilersClassesData(data) {
      this.boilersClassesData = data;
    },
    setFirstScreenData(data) {
      this.firstScreenData = data;
    },
    setSecondScreenData(data) {
      this.secondScreenData = data;
    },
    setThirdScreenData(data) {
      this.thirdScreenData = data;
    },
    stepBack() {
      this.$refs[`screen${this.step}`].emitChange();
      if (this.step === 5) {
        this.step = this.secondScreenData.solidFuel ? 4 : 2;
        return;
      }
      if (this.step > 1) {
        this.step--;
      }
    },
    moveToNextStepOrSave() {
      const currentScreenComponent = this.$refs[`screen${this.step}`];

      const errors = this.validators[`screen${this.step}`].isValid(currentScreenComponent);
      if (errors.atLeastOne) {
        currentScreenComponent.setErrors(errors);
        //if (this.step !== 1)
        return;
      }

      currentScreenComponent.emitChange();

      if (this.step === 2) {
        this.step = this.secondScreenData.solidFuel ? 3 : 5;
        return;
      }
      if (this.step === 5) {
        if (!this.thirdScreenData.isAddressSame) {
          this.step++;
          return;
        }
        const errors = this.validators[`screen5`].isValid(this.$refs[`screen5`], false);
        if (errors.atLeastOne) {
          this.$refs[`screen5`].setErrors(errors);
          return;
        }
        this.showSubmitDeclarationModal = true;
      } else {
        if (this.step === 6) {
          const errors = this.validators[`screen5`].isValid(this.$refs[`screen5`], false);
          if (errors.atLeastOne) {
            this.$refs[`screen5`].setErrors(errors);
            return;
          }
          this.showSubmitDeclarationModal = true;
          return;
        }
        this.step++;
      }
    },

    saveDeclaration: _.debounce(function (isDraft) {
      isDraft = !!isDraft;

      let screenComponent = null;
      for (let i = 1; i < 7; i++) {
        screenComponent = this.$refs[`screen${i}`];

        const errors = this.validators[`screen${i}`].isValid(screenComponent, isDraft);
        if (errors.atLeastOne) {
          this.step = i;
          screenComponent.setErrors(errors);
          return;
        }

        screenComponent.emitChange();
      }


      let payload = {
        "is_single_family_A08_01": this.firstScreenData.singleOrMultiFamily === "single",
        "is_multi_family_A08_02": this.firstScreenData.singleOrMultiFamily === "multi",
        "is_temporary_A08_03": this.firstScreenData.isTemporary,
        "after_01_07_2021": this.firstScreenData.after01072021,
        "multi_family_count": this.firstScreenData.multiFamilyCount ? this.firstScreenData.multiFamilyCount : null,
        "temporary_count": this.firstScreenData.temporaryCount ? this.firstScreenData.temporaryCount : null,
        "is_all_premises": this.firstScreenData.isAllPremises,
        "premises_count_A09_02": this.firstScreenData.premisesCount ? this.firstScreenData.premisesCount : null,
        "premises_list_A09_02": this.firstScreenData.premisesList ? this.firstScreenData.premisesList : null,
        "is_address_different_D05": !this.thirdScreenData.isAddressSame,
        "status": isDraft ? "DRAFT" : "SUBMITTED",
        "more_not_declared_C01": false,
        "sources_of_heat": this.secondScreenData.heatSources,
        "boiler_classes_count": this.boilersClassesData.boilerClassesCount,
        "used_fuels": this.fuelTypesData.usedFuels,
        "is_manager_D01": !this.thirdScreenData.isOwner,
        "person_or_company_name_D02": this.thirdScreenData.name,
        "contact_telephone_D03": this.thirdScreenData.phone,
        "email_D04": this.thirdScreenData.email,
        "polish_address": this.customAddressData.polishAddress,
        "foreign_address": this.customAddressData.foreignAddress,
        "type": this.declarationType,
        "has_statement": (this.thirdScreenData.hasStatement != null) ? this.thirdScreenData.hasStatement : false
      };

      if (this.declarationType === 'B') {
        payload.building_types = this.firstScreenData.buildingTypes;
        payload.special_symbol_A08_B = this.firstScreenData.specialSymbolA08B;
        payload.linked_declaration = null;

      }

      if (!this.declarationEditId) {
        DeclarationsModel.saveDeclaration(payload, this.building.id)
          .then(() => {
            this.closeDeclarationModal();
            this.$notify({
              group: 'zone',
              type: 'success',
              title: 'Sukces',
              text: isDraft ? 'Pomyślnie zapisano deklarację w wersji roboczej' : 'Pomyślnie złożono deklarację'
            });
            this.$store.commit('updateDeclarationsList');
          })
        .catch((err) => {
            let text = 'Pod czas zapisywania deklaracji wystąpił błąd po stronie serwera.';
            if (err.response && err.response.data && err.response.data.zone_error) {
              text = err.response.data.text;
            }
            this.$notify({
              group: 'zone',
              type: 'error',
              title: 'Błąd!',
              text: text
            });
          });
        return;
      }
      DeclarationsModel.updateDeclaration(payload, this.declarationEditId)
        .then(() => {
          this.closeDeclarationModal();
          this.$notify({
            group: 'zone',
            type: 'success',
            title: 'Sukces',
            text: isDraft ? 'Pomyślnie zapisano zmiany w deklaracji' : 'Pomyślnie złożono deklarację'
          });
          this.$store.commit('updateDeclarationsList');
        });
    }, 500),
    closeDeclarationModal() {
      this.$store.commit("closeDeclarationModal");
    },
    setStep(i) {
      this.step = i;
    }
  },

  computed: {
    declarationTypeTitle() {
      return {
        "A": "Formularz A - budynki i lokale mieszkalne",
        "B": "Formularz B - budynki i lokale niemieszkalne",
      }[this.declarationType];
    },
    building() {
      return this.$store.state.declarationBuilding;
    },
    nextStepButtonText() {
      let text = this.step === 5 && this.thirdScreenData.isAddressSame ? "Złóż" : "Przejdź dalej";
      text = this.step === 6 && !this.thirdScreenData.isAddressSame ? "Złóż" : text;
      return text;
    },

    declarationEditId() {
      return this.$store.state.declarationEditId;
    },

    declarationCloneId() {
      return this.$store.state.clonedDeclarationFinalId;
    }
  },

  mounted() {
    if (this.declarationEditId) {
      DeclarationsModel.getDeclarationById(this.declarationEditId)
        .then((res) => {
          const data = res.data;
          for (let i = 1; i < 7; i++) {
            this.$refs[`screen${i}`].setData(data);
          }

          this.thirdScreenData.isAddressSame = !data.is_address_different_D05;

          this.dataLoaded = true;
        });
    } else if (this.declarationCloneId) {
      DeclarationsModel.getDeclarationById(this.declarationCloneId)
        .then((res) => {
          const data = res.data;
          for (let i = 1; i < 7; i++) {
            this.$refs[`screen${i}`].setData(data);
          }

          this.thirdScreenData.isAddressSame = !data.is_address_different_D05;

          this.dataLoaded = true;
          this.$store.commit("resetDeclarationClonedFinalId");
        });
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}

.zone-modal {
  display: grid;
  grid-template-columns: 45% 55%;
  grid-template-rows: 10% 8% 72% 10%;
}

.zone-modal {
  width: 70rem;
  height: 45rem;
  padding: 1.5rem;
}

@media (max-height: 770px) {
  .zone-modal {
    height: 40rem;
  }
}


.header {
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 3;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

.form-block {
  padding-top: 1rem;
  display: flex;
  flex-direction: column;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 3;
  grid-row-end: 4;
}


.address {
  font-size: 1.3rem;
}

.text-input {
  height: 2rem;
  width: fit-content;
  min-width: 75%;
}

.half-input {
  width: fit-content;
  min-width: 50%;
  margin-left: .5rem;
}

.progress-bar-block {
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 2;
  grid-row-end: 2;
  margin: 0 -1.5rem;
}

.form-block {
  display: flex;
  flex-direction: column;
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 3;
  grid-row-end: 4;
}

.buttons-row {
  grid-column-start: -2;
  grid-column-end: -1;
  grid-row-start: -2;
  grid-row-end: -1;
  display: flex;
  flex-direction: row-reverse;
}

.buttons-row .btn-primary, .buttons-row .btn-outline-primary {
  min-width: 8rem;
  margin-left: 1rem;
  height: 2rem;
}

.locals-count-input {
  margin-bottom: .25rem;
}

.declaration-overlay {
  position: absolute !important;
  top: 9rem;
  left: 0;
  right: 0;
  bottom: 0;
}

.form-block {
  padding-top: 5px !important;
}


@media screen and (max-width: 1075px) {
  .zone-modal {
    -webkit-transform: none;
    transform: none;
    position: fixed;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    height: auto;
    width: auto;
    padding: 5px;
  }

  .form-block {
    overflow-y: auto;
    overflow-x: hidden;
  }

  .header {
    padding: 0.5rem;
    padding-right: 2rem;
  }

  .header h1 {
    font-size: 1rem;
    letter-spacing: 0rem;
  }

  .progress-bar-block {
    margin: 0 -5px;
  }

  .buttons-row {
    grid-column-start: -4;
  }

  .buttons-row .btn-primary, .buttons-row .btn-outline-primary {
    min-width: 4rem;
    margin-left: 5px;
    height: auto;
  }
}
</style>
